<template>
  <div id="main-control">
    <div class="sign-wrap">
      <main-menu v-if="activeMenu === 'main'" @menuCreateSelected="askForPermissions"/>
      <create-menu v-if="activeMenu === 'create'" @createPlaylist="createPlaylist"/>
      <playlist v-if="activeMenu === 'playlist'" :accessToken="accessToken"
      :name="playlistName"/>
    </div>
  </div>
</template>

<script>
import querystring from 'querystring'
import mainMenu from './MainMenu'
import createMenu from './CreateMenu'
import playlist from './Playlist'

export default {
  name: 'main-control',
  components: {mainMenu, createMenu, playlist},
  data () {
    return {
      activeMenu: 'main',
      accessToken: '',
      playlistName: ''
    }
  },
  mounted () {
    let urlParams = querystring.parse(this.$route.hash.substring(1))
    let accessToken = urlParams.access_token
    if (accessToken) {
      this.accessToken = accessToken
      this.selectActiveView('create')
    } else if (this.$route.query.error === 'access_denied') {
      alert('ha denegado el permiso')
    }
  },
  methods: {
    selectActiveView (view) {
      this.activeMenu = view
    },
    askForPermissions () {
      let clientId = 'e9c66479f929404294e29c31ebd82189'
      let state = this.generateRandomString(16)
      let scope = 'user-read-private user-read-email playlist-modify-public playlist-modify-private' +
        ' user-modify-playback-state'
      window.location.replace('https://accounts.spotify.com/authorize?' +
        querystring.stringify({
          client_id: clientId,
          response_type: 'token',
          redirect_uri: 'http://localhost:8080/create',
          state: state,
          scope: scope
        }))
    },
    generateRandomString (length) {
      let text = ''
      let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text
    },
    createPlaylist (playlistInfo) {
      this.playlistName = playlistInfo.name
      this.$emit('activePlaylistMode')
      this.selectActiveView('playlist')
      this.$router.replace('/playlist')
    }
  }
}
</script>

<style type="scss" scoped>
  .sign-wrap {
    margin-top: 0;
    padding: 50px;
    padding-top: 10px;
    border-radius: 50px;
    background-color: hsl(0, 0%, 8%);
    box-shadow: 0px 50px 45px -15px rgba(0, 0, 0, .5),
    0px 20px 10px -5px rgba(0, 0, 0, .5),
    0px 5px 20px 0px rgba(0, 0, 0, .5),
    0px 10px 30px rgba(0, 0, 0, .7) inset;
    border: 4px solid lighten(black, 12%);
    border-top: 4px solid black;
    border-bottom: 4px solid lighten(black, 16%);
  }

</style>



// WEBPACK FOOTER //
// src/components/MainControl.vue